export default __webpack_public_path__ + "static/media/illustration_1.9e00cdb5.png";